import { useParams } from 'react-router-dom';

import { DeployAppTab } from '@/components/deploy/deploy-app-tab';
import { EnvironmentSelector } from '@/components/shared/environment-selector';
import { useEnvironments } from '@/hooks/use-configuration';
import { useEnvironmentStore } from '@/stores/environment-store';

export function ProjectDeployPage() {
  const { projectKey } = useParams<{ projectKey: string }>();
  const key = projectKey ?? '';

  const { data: environments = [], isLoading: environmentsLoading } = useEnvironments(key);
  const { selectedEnvironmentId } = useEnvironmentStore();

  const hasEnvironments = environments.length > 0;

  return (
    <main id="main-content" className="mx-auto max-w-5xl">
      <header className="mb-4">
        <h1 className="text-2xl font-bold text-content">Deploy</h1>
        <p className="mt-1 text-sm text-content-secondary">
          Deployment management and operations
        </p>
      </header>

      {/* Environment selector */}
      <div className="mb-4">
        <EnvironmentSelector projectKey={key} />
      </div>

      {/* No environments message */}
      {!environmentsLoading && !hasEnvironments && (
        <p className="text-sm text-content-tertiary italic">
          No environments are available. Configure environments in Settings to use deployment features.
        </p>
      )}

      {/* Deploy content - only shown when environments exist and are loaded */}
      {!environmentsLoading && hasEnvironments && (
        <DeployAppTab projectKey={key} environmentId={selectedEnvironmentId} />
      )}
    </main>
  );
}
